<template>
  <div class="row p-3">
    <div class="col-lg-10 col-xs-12">
      <h1>
        Campos customizados de {{entity_translate[entity]}}
      </h1>
    </div>
    <div class="col-lg-2 col-xs-12">
      <button
        @click="newFieldMapping"
        class="btn full btn-primary f13 p-2 radius-0"
      >
        <font-awesome-icon icon="plus" />
        Novo
      </button>
    </div>
    <div
      v-for="field in field_mapping"
      :key="field.id"
      class="col-lg-12 col-xs-12"
    >
      <div class="row field_uni">
        <div class="col-lg-1">
          <input
            type="checkbox"
            v-model="checke_field"
            :value="field.id"
          />
        </div>
        <div class="col-lg-2">
          {{field.parameters.name}}
        </div>
        <div class="col-lg-2">
          {{field.parameters.required ? "Sim" : "Não"}}
        </div>
        <div class="col-lg-2">
          {{type_field_translate[field.parameters.type_field]}}
        </div>
        <div class="col-lg-2">
          {{field.parameters.hidden  ? "Sim" : "Não"}}
        </div>
        <div class="col-lg-2">
          {{field.parameters.value_field}}
        </div>
      </div>
    </div>
    <div class="col-lg-10">

    </div>

    <div class="col-lg-2">
      <button
        @click="save"
        class="btn full  btn-primary f13 p-2 radius-0"
      >
        Salvar
      </button>
    </div>
  </div>
</template>

<script>
import FieldMappingForm from "components/FieldMapping/Form.vue";
export default {
  components: { FieldMappingForm },
  props: ["entity", "entity_data"],
  data: () => ({
    checke_field: [],
    field_mapping: [],
  }),
  mounted() {
    this.loadFields();
    for (let id in this.entity_data.field_data.field_mapping_ids) {
      this.checke_field.push(
        parseInt(this.entity_data.field_data.field_mapping_ids[id])
      );
    }
  },
  methods: {
    newFieldMapping() {
      this.$modal.show(
        FieldMappingForm,
        {
          entity: "candidates",
          field_mapping: false,
        },
        {
          width: "50%",
          height: "auto",
          scrollable: true,
        },
        {
          "before-close": (event) => {
            this.loadFields();
          },
        }
      );
    },
    loadFields() {
      axios
        .get("/recruiters/field_mapping_entities/" + this.entity)
        .then((response) => {
          this.field_mapping = response.data;
        });
    },
    save() {
      let field = {};
      field["ids"] = this.checke_field;
      field[this.entity_data.name] = this.entity_data.id;
      this.entity_data.field_data.field_mapping_ids = this.checke_field;
      axios
        .post("/recruiters/selective_process_field_mapping", {
          field_mapping_ids: field,
        })
        .then((response) => {
          this.$toast.success("Dados Salvos com sucesso");
          this.$emit("close");
        });
      // (:field_mapping_ids).permit(:selective_process_id, ids: [])
    },
  },
  computed: {
    entity_translate() {
      return {
        candidates: "Candidato",
      };
    },
    type_field_translate() {
      return {
        text: "Texto",
        number: "Número",
      };
    },
  },
};
</script>
